var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlaze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 391,
    viewBox: "0 0 272 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M287.26 390.508C377.988 382.598 445.583 303.753 438.618 214.322C435.363 171.409 416.623 116.257 356.749 75.2431C306.33 40.5831 262.89 44.5481 246.386 15.2711C242.119 64.1751 272.051 89.0391 300.365 106.375C241.545 104.739 238.46 64.6651 192.888 34.2981C148.475 4.66207 84.358 -16.7759 0 17.7941C101.865 35.0611 135.607 140.078 142.671 172.576C123.422 154.19 71.78 122.597 29.254 136.963C112.509 182.052 90.262 253.32 135.389 316.655C167.058 365.257 224.341 395.332 287.069 389.998L287.259 390.508H287.26ZM217.032 297.03C180.551 266.475 176.098 212.395 207.396 175.789C238.695 139.183 293.656 134.416 330.397 164.874C367.138 195.333 371.332 249.509 340.033 286.115C308.735 322.721 253.773 327.488 217.032 297.03Z",
    fill: "url(#paint0_linear_1_719)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_719",
    x1: 316.24,
    y1: 40.696,
    x2: 101.416,
    y2: 298.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15939"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlaze);
export default __webpack_public_path__ + "static/media/Blaze.ccc629d830ad2668b3a5db4cc8c08899.svg";
export { ForwardRef as ReactComponent };